export function getSdk(client, withWrapper = (action, _operationName, _operationType) => action()) {
  return {
    content: (variables = undefined, requestHeaders = undefined) => withWrapper((wrappedRequestHeaders) => client.request(`query content($slug: [String]) {
    entries(slug: $slug) {
        ... on page_Entry {
            showInFooterMenu
            showInHeaderMenu
            title
            blocks {
                ... on blockHomeHeader_Entry {
                    typeHandle
                    title
                    text
                    images {
                        ... on media_Asset {
                            id
                            title
                            url(transform: "imageCard")
                        }
                    }
                }
                ... on blockHomeIntro_Entry {
                    typeHandle
                    title
                    text
                    featureTable {
                        heading
                        text
                    }
                }
                ... on blockAssociationContent_Entry {
                    typeHandle
                    typeHandle
                }
                ... on blockText_Entry {
                    typeHandle
                    text
                    title
                }
                ... on blockImage_Entry {
                    typeHandle
                    images {
                        ... on media_Asset {
                            id
                            title
                            url(transform: "imageFullWidth")
                        }
                    }
                }
                ... on blockFeatures_Entry {
                    typeHandle
                    title
                    text
                    featureTable {
                        heading
                        text
                    }
                }
                ... on blockPartners_Entry {
                    typeHandle
                    title
                    text
                    partners {
                        ... on partner_Category {
                            id
                            images {
                                ... on media_Asset {
                                    id
                                    title
                                    url(transform:"logo")
                                }
                            }
                        }
                    }
                }
                ... on blockDownloads_Entry {
                    typeHandle
                    title
                    text
                    downloads {
                        ... on downloads_Asset {
                            id
                            title
                            url
                        }
                    }
                }
                ... on blockCaptionText_Entry {
                    typeHandle
                    text
                }
                ... on blockPageHeader_Entry {
                    typeHandle
                    text
                    title
                }
                ... on blockNews_Entry {
                    typeHandle
                    title
                    newsLayout
                    number
                    pageLink {
                        uri
                    }
                }
            }
        }
    }
}`, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'content', 'query'),
    navigation: (variables = undefined, requestHeaders = undefined) => withWrapper((wrappedRequestHeaders) => client.request(`query navigation {
    entries(section: "pages" ) {
        ... on page_Entry {
            id
            showInHeaderMenu
            showInFooterMenu
            slug
            title
            parent {
                id
            }
        }
    }
}`, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'navigation', 'query'),
    news: (variables = undefined, requestHeaders = undefined) => withWrapper((wrappedRequestHeaders) => client.request(`query news($limit: Int) {
   newsEntries(limit: $limit) {
        ... on news_Entry {
            id
            title
            text
            images {
                ... on media_Asset {
                    id
                    title
                    url(transform: "imageFullWidth")
                }
            }
            date
            uri
        }
    }
}`, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'news', 'query'),
    newsDetails: (variables = undefined, requestHeaders = undefined) => withWrapper((wrappedRequestHeaders) => client.request(`query newsDetails($slug: [String]) {
    entries(slug: $slug) {
        ... on news_Entry {
            id
            title
            text
            images {
                ... on media_Asset {
                    id
                    title
                    url(transform: "imageFullWidth")
                }
            }
            date
            uri

            blocks {
                ... on blockHomeHeader_Entry {
                    typeHandle
                    title
                    text
                    images {
                        ... on media_Asset {
                            id
                            title
                            url(transform: "imageCard")
                        }
                    }
                }
                ... on blockHomeIntro_Entry {
                    typeHandle
                    title
                    text
                    featureTable {
                        heading
                        text
                    }
                }
                ... on blockAssociationContent_Entry {
                    typeHandle
                    typeHandle
                }
                ... on blockText_Entry {
                    typeHandle
                    text
                    title
                }
                ... on blockImage_Entry {
                    typeHandle
                    images {
                        ... on media_Asset {
                            id
                            title
                            url(transform: "imageFullWidth")
                        }
                    }
                }
                ... on blockFeatures_Entry {
                    typeHandle
                    title
                    text
                    featureTable {
                        heading
                        text
                    }
                }
                ... on blockPartners_Entry {
                    typeHandle
                    title
                    text
                    partners {
                        ... on partner_Category {
                            id
                            images {
                                ... on media_Asset {
                                    id
                                    title
                                    url(transform:"logo")
                                }
                            }
                        }
                    }
                }
                ... on blockDownloads_Entry {
                    typeHandle
                    title
                    text
                    downloads {
                        ... on downloads_Asset {
                            id
                            title
                            url
                        }
                    }
                }
                ... on blockCaptionText_Entry {
                    typeHandle
                    text
                }
                ... on blockPageHeader_Entry {
                    typeHandle
                    text
                    title
                }
                ... on blockNews_Entry {
                    typeHandle
                    title
                    newsLayout
                    number
                    pageLink {
                        uri
                    }
                }
            }
        }
    }
}`, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'newsDetails', 'query'),
    organisation: (variables = undefined, requestHeaders = undefined) => withWrapper((wrappedRequestHeaders) => client.request(`query organisation($organisationId: [QueryArgument]) {
    organisationsEntries(organisationId: $organisationId) {
        ... on organisation_Entry {
            id
            organisationId
            disabledInOase
            title
            blocksDashboard {
                ... on blockText_Entry {
                    typeHandle
                    text
                    postDate
                }
                ... on blockCaptionText_Entry {
                    typeHandle
                    text
                    title
                }
            }
            blocksFrontendAlert {
                ... on blockText_Entry {
                    typeHandle
                    text
                }
                ... on blockCaptionText_Entry {
                    typeHandle
                    text
                    title
                }
            }
            blocksFrontend {
                ... on blockText_Entry {
                    typeHandle
                    text
                }
                ... on blockCaptionText_Entry {
                    typeHandle
                    text
                    title
                }
            }
        }
    }
}`, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisation', 'query')
  }
}